<template>
  <div id="app">
    <ModalAlert />
    <router-view />
  </div>
</template>

<script>
import ModalAlert from "./components/ModalAlert";

export default {
  name: "App",
  components: {
    ModalAlert
  }
};
</script>

<style>
.infinite-loading-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.img {
  height: auto;
  max-width: 100%;
  border: none;
  -webkit-border-radius: 0;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
